const Divider = ({ title }) => {
  return (
    <div className="relative">
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className="w-full border-t border-gray-300" />
      </div>
      {title && (
        <div className="relative flex justify-start">
          <span className="pr-3 bg-white text-sm font-medium text-gray-900">
            {title}
          </span>
        </div>
      )}
    </div>
  );
};

export default Divider;
